import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCalendarAdd4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"calendar-add-4"} maskId="square-filled-radius-0-stroke-1-IconCalendarAdd4"><path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H16V4H8V2H7V4ZM12.4991 9H11.4991V12H8.5V13H11.4991V16H12.4991V13H15.5V12H12.4991V9Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconCalendarAdd4;
